import "./styles.less";

import { Breadcrumb, Skeleton, Typography } from "antd";
import React, { useContext } from "react";

import { ArrowRightIcon } from "../../CustomIcons/web";
import { ConfigStateContext } from "../../../Contexts/Configurations/context";
import Head from "next/head";
import { formatMoney } from "../../../Utils/Functions";
import { useSEO } from "../hook";

const { Text, Link } = Typography;

export const BreadCrumbs = () => {
	const { seoMetaTags, error, loading } = useSEO();

	if (loading)
		return (
			<Skeleton
				title={false}
				paragraph={{
					rows: 1,
					width: 500,
					style: { margin: 0 },
				}}
				active
			/>
		);

	if (error || !seoMetaTags) return null;

	return <BreadcrumbComponent breadcrumbs={seoMetaTags.breadcrumbs} />;
};

export const BreadcrumbComponent = ({ breadcrumbs }) => {
	const { main_domain } = useContext(ConfigStateContext);

	const jsonData = {
		"@context": "https://schema.org",
		"@type": "BreadcrumbList",
		itemListElement: breadcrumbs?.filter( e => e.text && e.url )
		.map((item, i) => ({
			"@type": "ListItem",
			position: i + 1,
			name: item.text,
			item: `https://${main_domain}${item.url}`,
		})),
	};

	return (
		<React.Fragment>
			<Head>
				<script
					type="application/ld+json"
					dangerouslySetInnerHTML={{
						__html: JSON.stringify(jsonData),
					}}></script>
			</Head>
			<Breadcrumb
				className={"custom-page-breadcrumb"}
				routes={breadcrumbs.map((b, i) => ({
					...b,
					breadcrumbName: b.text,
					path: "breadcrumb_" + b.text + "_" + i,
				}))}
				itemRender={(route, params, routes, paths) => {
					return <BreadcrumbItemRender route={route} routes={routes} />;
				}}
				separator={<ArrowRightIcon />}
			/>
		</React.Fragment>
	);
};

export function BreadcrumbItemRender({ route, routes }) {

	let cadena = route.text;
	if (cadena.indexOf("página") !== -1) {
		const page = cadena.substring(7, cadena.length);
		cadena = cadena.replace(page, formatMoney(page));
	} else null;

	const first = routes.findIndex(r => r.path == route.path) === 0;
	const item = (
		<Link href={route.url} className="custom-breadcrumb-link">
			{cadena}
		</Link>
	);

	return (
		<React.Fragment>
			{first ? (
				<Text style={{ whiteSpace: "nowrap" }}>
					<span className="ubication-text">{"Estás en" + ":"}</span> {item}
				</Text>
			) : (
				item
			)}
		</React.Fragment>
	);
}
